module.exports = __webpack_public_path__ + "img/instagram.feab23bf.svg";